module.exports = __webpack_public_path__ + "img/meta.f8c6c5ad.png";